import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Link as RouterLink } from 'react-router-dom'
import { Collapse, List } from '@mui/material'
import { useSelector } from 'react-redux'
import CustomListItem from '../CustomListItem/index'

const CustomList = ({ t, location, list, handleDrawerOptions, expandedMenuItem }) => {
  const permissions = useSelector(state => state.permissions.permissions)

  const canView = (path) => {
    if (!path) return true
    if (!permissions || Object.keys(permissions).length === 0) return true
    const normalizedPath = path?.endsWith('/') ? path.slice(0, -1) : path
    if (permissions[normalizedPath] === undefined) return true
    return permissions[normalizedPath]?.canView === true
  }

  return (
    <List>
      {list.map((item1) => {
        return (
          <Fragment key={item1.id}>
            {item1.sectionChilds.map((item) => {
              const NavIcon = item.icon

              // if (item.hasSideBarOption && canView(item.path)) {
              //   const visibleSubMenus = item.subMenus.filter(sub => canView(sub.path))

              const visibleSubMenus = item.subMenus.filter(sub => canView(sub.path))
              const isVisible = item.subMenus.length > 0
                ? visibleSubMenus.length > 0 // parent shows if any child visible
                : canView(item.path) // no children check own path

              if (item.hasSideBarOption && isVisible) {
                // 👇 check if any submenu is active
                // const isSubMenuActive = item.subMenus.some(sub => location.pathname === sub.path)
                // const isActive = item.path === location.pathname || isSubMenuActive
                const isSubMenuActive = item.subMenus.some(sub => location?.pathname === sub.path)
                const isActive = item.path === location?.pathname || isSubMenuActive

                return (
                  <Fragment key={item.key}>
                    <CustomListItem
                      id={`sidebar_${item.label}`}
                      to={item.subMenus.length ? '' : item.path}
                      component={RouterLink}
                      onClick={() => handleDrawerOptions(item.label)}
                      selected={isActive}
                      sx={{
                        color: (theme) => isActive ? theme.colors.white : theme.colors.grey500,
                        fontWeight: isActive ? '800' : '400',
                        borderLeft: (theme) =>
                          isActive && !item.subMenus.length // 👈 only highlight parent if no submenus
                            ? `5px solid ${theme.colors.neon} !important`
                            : 'none',
                        '&:hover': {
                          borderLeft: (theme) =>
                            `5px solid ${theme.colors.gunmetalBlue} !important`
                        }
                      }}
                      icon={<NavIcon />}
                      text={t(item.label)}
                      expandless={
                        item.subMenus.length > 0 &&
                        expandedMenuItem.includes(item.label)
                      }
                      iconStyle={{
                        '& .MuiSvgIcon-root': {
                          fill: (theme) => theme.colors.white
                        },
                        minWidth: '40px'
                      }}
                      hasSubMenu={Boolean(item?.subMenus.length)}
                    />
                    {visibleSubMenus.length
                      ? (
                          visibleSubMenus.map((subItem) => {
                            // 👇 exact match for submenu
                            const isSubActive = location?.pathname === subItem.path
                            return (
                              <Collapse
                                in={expandedMenuItem.includes(item.label)}
                                timeout='auto'
                                unmountOnExit
                                key={subItem.key}
                              >
                                <List component='div' disablePadding>
                                  <CustomListItem
                                    sx={{
                                      color: (theme) => isSubActive ? theme.colors.white : theme.colors.grey500, // 👈 fix color
                                      pl: 4,
                                      borderLeft: (theme) =>
                                        isSubActive // 👈 exact match
                                          ? `5px solid ${theme.colors.neon} !important`
                                          : 'none',
                                      '&:hover': {
                                        borderLeft: (theme) =>
                                          `5px solid ${theme.colors.gunmetalBlue} !important`
                                      }
                                    }}
                                    isbutton
                                    id={`sidebar_${subItem.label}`}
                                    to={subItem.path}
                                    component={RouterLink}
                                    text={t(subItem.label)}
                                    icon={subItem.icon ? <subItem.icon /> : <></>}
                                    hasSubMenu={false}
                                    iconStyle={{
                                      '& .MuiSvgIcon-root': {
                                        fill: (theme) => theme.colors.white,
                                        width: '20px'
                                      }
                                    }}
                                  />
                                </List>
                              </Collapse>
                            )
                          })
                        )
                      : <></>}
                  </Fragment>
                )
              }
              return null
            })}
          </Fragment>
        )
      })}
    </List>
  )
}

CustomList.defaultProps = {
  list: [],
  handleDrawerOptions: () => {},
  expandedMenuItem: []
}

CustomList.propTypes = {
  t: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  list: PropTypes.array.isRequired,
  handleDrawerOptions: PropTypes.func.isRequired,
  expandedMenuItem: PropTypes.array.isRequired
}

export default CustomList
